import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "va-search" }

import {PropType, ref} from "vue";
import {VASearchItem} from "./typings";
import VATabs from "../VATabs/VATabs";
import VASelect from "../VASelect/VASelect"
import VATabsCascade from "../VATabsCascade/VATabsCascade";
import VASelectCascade from "../VASelectCascade/VASelectCascade";


export default /*@__PURE__*/_defineComponent({
  __name: 'VASearch',
  props: {
  options: {
    type: Array as PropType<Array<VASearchItem>>,
    required: true,
  },
  size: {
    type: String,
    default: 'small'
  }
},
  emits: ['on-search'],
  setup(__props, { expose: __expose, emit: __emit }) {


const components = {
  'tabs': VATabs,
  'select': VASelect,
  'select-cascade': VASelectCascade,
  'tabs-cascade': VATabsCascade
}

const emit = __emit
const props = __props

const source = ref({})

const changeItem = (item: VASearchItem) =>{
  if(item.search !== false){
    onSearch()
  }
}

const onSearch = () => {
  console.log("parseValue-->", parseValue())
  emit('on-search', parseValue())
}

// 根据search items解析参数，有query，有正常查询的
const parseValue = () => {
  if (!props.options)
    return {}

  const result = {query: []}     // 初始化查询参数
  const _push = (item: VASearchItem) =>{
    console.log(source.value, item.field)
    if (item.paramsType === 'query'){
      result.query.push({
        key: item.field,
        val: source.value[item.field].toString(),
        type: item.queryType || 'eq'
      })
    }        // 如果查询类型是query，则需要添加到query查询内
    else{
      if (item.fieldType === 'number' && source.value[item.field] === ""){
        return
      }
      result[item.field] = source.value[item.field]     // 否则直接赋值即可
    }
  }
  // 循环查询项，查询时，把查询项根据查询类型插入到查询参数中
  props.options.map((item: VASearchItem) => {
    if (!(item.field in source.value) || source.value[item.field] === undefined)     // 此处判断，是为搜索框值为空，则从params中去除
      return
    _push(item)
    // 级联的也添加
    // if(item.options?.child){
    //   _push(item.options.child)
    // }
  })
  return result
}
__expose({ parseValue, onSearch, source });

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "search-item",
        key: item.field
      }, [
        (item.slot)
          ? _renderSlot(_ctx.$slots, item.slot, {
              key: 0,
              item: item,
              data: source.value
            })
          : (item.tagType in components)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(components[item.tagType]), {
                key: 1,
                value: source.value[item.field],
                "onUpdate:value": ($event: any) => ((source.value[item.field]) = $event),
                options: item.options,
                width: item.width || '136px',
                size: __props.size,
                placeholder: item.placeholder,
                onOnChange: ($event: any) => (changeItem(item))
              }, null, 40, ["value", "onUpdate:value", "options", "width", "size", "placeholder", "onOnChange"]))
            : (_openBlock(), _createBlock(_component_a_input, {
                key: 2,
                value: source.value[item.field],
                "onUpdate:value": ($event: any) => ((source.value[item.field]) = $event),
                style: _normalizeStyle(`width: ${item.width || '136px'}`),
                placeholder: item.placeholder,
                size: __props.size,
                onPressEnter: ($event: any) => (changeItem(item))
              }, null, 8, ["value", "onUpdate:value", "style", "placeholder", "size", "onPressEnter"]))
      ]))
    }), 128)),
    _createVNode(_component_a_button, {
      type: "primary",
      style: {"margin-left":"5px"},
      size: __props.size,
      onClick: onSearch
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("搜索")
      ])),
      _: 1
    }, 8, ["size"])
  ]))
}
}

})